import React from 'react'

import {
  MenuLink, Title, Subtitle, Tag
} from 'bloomer'

const HouseItem = ({house, isCurrent, isOwner, onClick}) => {
  return (
    <li onClick={onClick}>
      <MenuLink>
        <Title isSize={4}>
          {house.name}
          {' '}
          {isCurrent &&
            <Tag isColor="success">Atual</Tag>
          }
        </Title>
        <Subtitle isSize={6}>
          {house.description}<br/>
          {!isOwner &&
            <Tag isColor="info">
              Convidado de {`${house.owner.firstName} ${house.owner.lastName}`}
            </Tag>
          }
        </Subtitle>
      </MenuLink>
    </li>
  )
}

export default HouseItem



// WEBPACK FOOTER //
// ./src/pages/SwitchHousePage/HouseItem.js